// use-get-customer-sell-bo.tsx
import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { CustomersBoResponse } from '@utils/types/back-office/customers.ts';
import { GET_URL } from '@utils/api/endpoints.ts';

export const useGetCustomersToSellBo = (searchQuery: string = '') => {
  const urlOffset = 0;
  const urlLimit = 25;

  const fetchCustomers = async (
    limit: number,
    offset: number,
    search: string
  ): Promise<CustomersBoResponse> => {
    let url = GET_URL(String(offset), String(limit)).getCustomerSellPlansBo!;

    const q = search.trim();
    if (q) {
      const qValue = /^\d+$/.test(q) ? `id:eq:${q}` : `name:ilike:%${q}%`;
      url += `&q=${encodeURIComponent(qValue)}`;
    }

    const res = await Axios.get<CustomersBoResponse>(url);
    return res.data;
  };

  const isSearching = !!searchQuery.trim();
  const queryKey = [
    'customers-modal',
    urlOffset,
    urlLimit,
    isSearching ? searchQuery : ''
  ];

  return useQuery<CustomersBoResponse, AxiosError<BaseError>>(
    queryKey,
    () => fetchCustomers(urlLimit, urlOffset, searchQuery),
    {
      keepPreviousData: false,
      staleTime: 0,
      useErrorBoundary: false
    }
  );
};
